// extracted by mini-css-extract-plugin
module.exports = {"Confirmation":"Confirmation_Confirmation__f1Jul","Buttons":"Confirmation_Buttons__202KT","AdditionalText":"Confirmation_AdditionalText__2VGOr"};